<template>
  <div>
    <Loading />
    <UniRequestDetails role="admin" />
  </div>
</template>

<script>
const UniRequestDetails = () =>
  import("../../../components/university/UniRequestDetails");

export default {
  components: { UniRequestDetails }, // NOTE (c-proposal) component of proposal
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../../assets/fonts/IRANSans(FaNum).ttf");
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #d6bbc0;
  border-bottom: 1px solid #c8ced3;
}
.color {
  background-color: #0c4961;
  color: white;
}
</style>
